module.exports = __webpack_public_path__ + "img/bespoke70_18.26e67f4e.jpg";